/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as r from "react";
import t from "prop-types";
import { Animation as p } from "./Animation.mjs";
const n = class n extends r.Component {
  /**
   * @hidden
   */
  render() {
    const {
      direction: o,
      children: i,
      ...s
    } = this.props, a = {
      transitionName: `slide-${o}`
    };
    return /* @__PURE__ */ r.createElement(p, { ...a, ...s }, i);
  }
};
n.propTypes = {
  children: t.oneOfType([
    t.arrayOf(t.node),
    t.node
  ]),
  childFactory: t.any,
  className: t.string,
  direction: t.oneOf([
    "up",
    "down",
    "left",
    "right"
  ]),
  component: t.string,
  id: t.string,
  style: t.any
}, n.defaultProps = {
  appear: !1,
  enter: !0,
  exit: !0,
  transitionEnterDuration: 300,
  transitionExitDuration: 300,
  direction: "down"
};
let e = n;
export {
  e as Slide
};
